
import TableList from '@/components/TableList/index.vue';
import { parseTime } from '@/filters/index';

export default {
  components: {
    TableList: TableList
  },

  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    batchIds: {
      type: String,
      default: ''
    },
    showAuditDialog: {
      type: Function,
      default: function _default() {}
    },
    showMaterialDialog: {
      type: Function,
      default: function _default() {}
    },
    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        creative_name: ''
      },
      pagination: {
        total: 0
      },
      parseTime: parseTime
    };
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        prop: 'selection',
        type: 'selection',
        fixed: 'left',
        selectable: function selectable(row, index) {
          return ['playable 2D', 'playable 3D', '动态endcard', 'interactive video'].every(function (val) {
            return val !== row.creative_type;
          }) && row.is_dco !== 1 && ([1, 5, 6, 7].some(function (item) {
            return item === Number(row.status);
          }) || [2, 3].some(function (item) {
            return item === Number(row.status);
          }) && row.is_active === 1);
        }
      }, {
        label: '审核ID',
        prop: 'id'
      }, {
        label: '素材名称',
        prop: 'creative_name'
      }, {
        label: 'UUID',
        prop: 'offer_uuid'
      }, {
        label: '包名',
        prop: 'package_name'
      }, {
        label: 'Last Operator',
        slot: 'last-operator-cell'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    }
  },

  watch: {
    batchIds: function batchIds(val) {
      if (val === '') this.$refs.offerList.clearSelection();
    }
  },
  methods: {
    isMp4: function isMp4(link) {
      return (/\.mp4$/.test(link)
      );
    },
    isImage: function isImage(link) {
      return (/(\.jp(e)?g|\.png|\.gif)$/.test(link)
      );
    },
    handleAudit: function handleAudit(index, row) {
      this.showAuditDialog(row);
    },
    handleDetail: function handleDetail(index, row) {
      this.showMaterialDialog(row);
    }
  }
};